import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor() { }

  reload(): void {
    window.location.reload();
  }

  _find(prop, id): any {
    return this[`_${prop}`].find( (item) => item.id == id );
  }

  _findBy(prop, evaluator): any {
    return this[`_${prop}`].find(evaluator);
  }

  _update(prop, values) {
    if (Array.isArray(values)) {
      this[`_${prop}`] = values;
    } else {
      let original_item = this[`_${prop}`].find( (item) => item.id == values.id );
      if (original_item) {
        original_item = Object.assign(original_item, values);
      } else {
        this[`_${prop}`].push(values);
      }
    }
  }

  _delete(prop, id) {
    this[`_${prop}`] = this[`_${prop}`].filter( (item) => item.id != id );
  }

  _unpack(items : any[], stateProp: string = '', each: Function | null = null) {
    if (typeof items === 'undefined') return [];

    return items.map((item) => {
      if (typeof item === 'number') return item;

      if (each) item = each(item);

      if (stateProp) this._update(stateProp, item);

      return item.id;
    });
  }

  _pack(ids: number[], stateProp: string, each: Function | null = null) {
    return ids.map((id) => {
      let item = this._find(stateProp, id);

      if (each) item = each(item);

      return item;
    });
  }
}
